import {
  navigateTo,
  postJsonAsync,
  getJsonAsync
} from 'shared/actions';
import { setErrorList } from 'shared/error/actionTypes';
import { setPaymentMessage } from '../home/actionTypes';
import {
  setPayInFullDisabled,
  loadCheckout,
  updateSquadQuantity,
  updateVirtualEventQuantity,
  updateCartTotal,
  updateSchedulerSquadCount,
  updateSchedulerVirtualEventCount,
  setProcessingStarted,
  setProcessingFinished,
  setAlreadyValidated,
  clearPayment,
  setTermsUrl,
  setAgreeToTerms,
  setValidationMessages,
  createCheckoutPayment,
  showPaymentDialogEmbeddedForm,
  hidePaymentDialogEmbeddedForm
} from './actionTypes';
import {
  displayEventPriceDetailModal,
  setEventPriceDetailData
} from 'shared/eventPriceDetailsModal/actionTypes';
import {
  getShoppingCart,
  setShoppingCart
} from '../actions';

export const handleSquadFeesButtonClick = (eventPrice, eventAddOnFees) => (dispatch) => {
  dispatch(displayEventPriceDetailModal());
  dispatch(setEventPriceDetailData(eventPrice, eventAddOnFees));
};

export const restoreLocalDataForCheckout = () => (dispatch) => new Promise((resolve) => {
  let cart = JSON.parse(localStorage.cart || null) || [];

  dispatch(loadCheckout(cart));
  resolve();
});

export const processPayment = (paymentDetail) => (dispatch, getState) => {
  const regState = getState().registration;
  const { tournamentPhoneNumber } = regState.base;
  let entries = regState.shared.cartEntries;
  let cartVirtualEntries = regState.shared.cartVirtualEntries;

  const paymentDetailModel = {
    PaymentId: paymentDetail.PaymentId,
    AlreadyValidated: regState.payment.alreadyValidated,
    TournamentId: paymentDetail.TournamentId,
    Entries: entries,
    virtualEntries: cartVirtualEntries,
    BypassWebHooks: localStorage.bypassWebHooks
  };

  dispatch(setProcessingStarted());
  dispatch(setPayInFullDisabled(true));
  dispatch(postJsonAsync(`registration/tournament/${paymentDetailModel.TournamentId}/entry`, paymentDetailModel))
    .then(() => {
      delete localStorage.cart;
      if (localStorage.tempCartEntries)
        delete localStorage.tempCartEntries;
      dispatch(clearPayment());
      dispatch(setProcessingFinished());
      dispatch(navigateTo(''));

      const paymentMessage = regState.base.paymentSuccessMessage;

      dispatch(setPaymentMessage(paymentMessage.replace('#{phoneNum}', tournamentPhoneNumber)));
    })
    .catch(() => {
      // Ignoring error.
      delete localStorage.cart;
      if (localStorage.tempCartEntries)
        delete localStorage.tempCartEntries;
      dispatch(clearPayment());
      dispatch(setProcessingFinished());
      dispatch(navigateTo(''));

      const paymentMessage = regState.base.paymentSuccessMessage;

      dispatch(setPaymentMessage(paymentMessage.replace('#{phoneNum}', tournamentPhoneNumber)));
    });

  if (localStorage.bypassWebHooks)
    delete localStorage.bypassWebHooks;
};

export const validateCart = () => (dispatch, getState) => new Promise(resolve => {
  const tournamentId = getState().registration.base.tournamentId,
    cart = getShoppingCart();

  dispatch(setAlreadyValidated(false));
  dispatch(setPayInFullDisabled(true));
  dispatch(postJsonAsync(`registration/tournament/${tournamentId}/entry/validate`, {
    entries: cart.squads,
    virtualEntries: cart.virtualEvents
  }))
    .then(() => {
      dispatch(setPayInFullDisabled(false));
      dispatch(setAlreadyValidated(true));
      resolve();
    })
    .catch(() => resolve()); // resolve promise on fail because erros are manage inside postJsonAsync
});

export const openPaymentDialog = ({ amount, cart }) => (dispatch, getState) => {
  const { registration } = getState();
  const tournamentId = registration.base.tournamentId;
  const tournamentStripeKey = registration.base.tournamentStripeKey;
  const squadIds = cart.squads;
  const squadvirtualEntries = cart.virtualEvents;

  let body = {
    TournamentId: tournamentId,
    SquadEntries: squadIds,
    SquadVirtualEntries: squadvirtualEntries
  };

  dispatch(postJsonAsync(`registration/tournament/createSession`, body))
    .then(response => {
      const publishableKey = tournamentStripeKey;
      const stripe = window.Stripe(publishableKey);
      const sessionId = response.paymentId;
      const errorMessages = response.messages;
      const useEmbeddedPaymentForm = response.useEmbeddedPaymentForm;

      if (errorMessages && errorMessages.length > 0) {
        dispatch(setValidationMessages(errorMessages));
      }
      else if (amount == 0) {
        dispatch(processPayment({ PaymentId: sessionId, TournamentId: cart.tournamentId }));
      }
      else {
        if (useEmbeddedPaymentForm === true) {
          dispatch(showPaymentDialogEmbeddedForm());
        } else {
          stripe.redirectToCheckout({
            sessionId
          });
        }
      }
    });
};

export const closePaymentDialogEmbeddedForm = () => (dispatch, getState) => {
  dispatch(hidePaymentDialogEmbeddedForm());
};

export const createPaymentClientSecret = (cart) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const { registration } = getState();
    const tournamentId = registration.base.tournamentId;
    const squadIds = cart.squads;
    const squadVirtualEntries = cart.virtualEvents;

    let body = {
      TournamentId: tournamentId,
      SquadEntries: squadIds,
      SquadVirtualEntries: squadVirtualEntries
    };

    dispatch(postJsonAsync(`registration/tournament/createSession`, body))
      .then(response => {
        const errorMessages = response.messages;

        if (errorMessages && errorMessages.length > 0) {
          dispatch(setValidationMessages(errorMessages));
          reject(errorMessages); // Reject the promise with error messages
        } else {
          dispatch(createCheckoutPayment(response));
          resolve(response); // Resolve the promise with the session ID
        }
      })
      .catch(error => {
        reject(error); // Ensure the promise is rejected on network or other errors
      });
  });
};


export const removeSquadItemFromCart = id => dispatch => {
  let cart = JSON.parse(localStorage.cart || null) || [];
  let squadsInCart = cart.squads || [];
  let squadInCart = squadsInCart.find(item => item.id == id);

  if (squadInCart) {
    dispatch(updateSchedulerSquadCount(squadInCart, 0));
  }

  cart.squads = squadsInCart.filter(item => item.id != id);
  localStorage.cart = JSON.stringify(cart);
  dispatch(setErrorList([]));
  dispatch(loadCheckout(cart));
  dispatch(validateCart());
};

export const removeVirtualEventFromCart = id => dispatch => {
  let cart = JSON.parse(localStorage.cart || null) || [];
  let virtualEventsInCart = cart.virtualEvents || [];
  let virtualEventInCart = virtualEventsInCart.find(item => item.id == id);

  if (virtualEventInCart) {
    dispatch(updateSchedulerVirtualEventCount(virtualEventInCart, 0));
  }

  cart.virtualEvents = virtualEventsInCart.filter(item => item.id != id);
  localStorage.cart = JSON.stringify(cart);
  dispatch(setErrorList([]));
  dispatch(loadCheckout(cart));
  dispatch(validateCart());
};

export const handleOnSquadQuantityChange = data => (dispatch, getState) => {
  dispatch(setValidationMessages(null));
  dispatch(updateSquadQuantity(data));
  dispatch(updateCartTotal());

  const tournamentId = getState().registration.base.tournamentId;
  let shoppingCart = getShoppingCart(),
    item = shoppingCart.squads.find(x => x.id === data.squadId) || null;

  if (item === null) return;
  item.quantity = Number(data.inputValue);
  dispatch(updateSchedulerSquadCount(item, data.inputValue));
  dispatch(setShoppingCart(shoppingCart, tournamentId));
  dispatch(loadCheckout(shoppingCart));
  dispatch(validateCart());
};

export const handleOnVirtualEventQuantityChange = data => (dispatch, getState) => {
  dispatch(updateVirtualEventQuantity(data));
  dispatch(updateCartTotal());

  const tournamentId = getState().registration.base.tournamentId;
  let shoppingCart = getShoppingCart(),
    item = shoppingCart.virtualEvents.find(x => x.id === data.virtualEventId) || null;

  if (item === null) return;
  item.quantity = Number(data.inputValue);
  dispatch(updateSchedulerVirtualEventCount(item, data.inputValue));
  dispatch(setShoppingCart(shoppingCart, tournamentId));
  dispatch(loadCheckout(shoppingCart));
  dispatch(validateCart());
};

export const retrieveTermsUrl = tournamentId => dispatch => {
  dispatch(getJsonAsync(`tournament/${tournamentId}/restriction`))
    .then(data => dispatch(setTermsUrl(data == null ? null : data.termsUrl)));
};

export const handleAgreeToTermsClick = checked => dispatch => {
  dispatch(setAgreeToTerms(checked));
};

export const resetAgreeToTerms = () => dispatch => {
  dispatch(setAgreeToTerms(false));
};

export const resetValidationMesssages = () => dispatch => {
  dispatch(setValidationMessages(null));
};



// WEBPACK FOOTER //
// ./src/features/registration/checkout/actions.js